import ImgDescCard from 'components/ImgDescCard';
import styled from 'styled-components';
import { vw } from 'components/common/Common';

const NumberList = styled.ol`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  border-radius: 2px;
  overflow: hidden;
`;

const NumberItem = styled.li`
  display: grid;
  grid-template-columns: ${vw(64)} 1fr;
  align-items: center;
  gap: ${vw(32)};
  padding: ${vw(16)} ${vw(12)};
  border-bottom: 1px solid #dde2e4;
  &:last-child {
    border-bottom: none;
  }
`;

const ItemIndex = styled.span`
  font-size: 40px;
  font-weight: 600;
  color: #050a30;
`;

const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const ItemTitle = styled.h3`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #050a30;
  line-height: normal;
`;

const ItemText = styled.p`
  margin: 0;
  font-size: 24px;
  color: #424748;
  line-height: normal;
`;

const WhyChoose = () => {
  const steps = [
    {
      title: 'Apply',
      text: 'Submit your affiliate application',
    },
    {
      title: 'Onboard',
      text: 'Receive your custom tracking link and creative kit.',
    },
    {
      title: 'Promote',
      text: 'Share your links through your social channels.',
    },
    {
      title: 'Earn',
      text: 'Get fast, verified payouts on every confirmed booking.',
    },
  ];

  return (
    <ImgDescCard
      isLeft
      imgSrc="/imgs/webp/affiliate/snow-capped.webp"
      imgAlt="Private jet on runway with snow-capped mountains, representing luxury charter flights and scenic adventure."
      title="How to Get Started"
    >
      <NumberList>
        {steps.map((item, idx) => (
          <NumberItem key={idx}>
            <ItemIndex>{String(idx + 1).padStart(2, '0')}.</ItemIndex>
            <ItemContent>
              <ItemTitle>{item.title}</ItemTitle>
              <ItemText>{item.text}</ItemText>
            </ItemContent>
          </NumberItem>
        ))}
      </NumberList>
    </ImgDescCard>
  );
};

export default WhyChoose;
